import { DrawerHeader } from '@chakra-ui/react'
import { mdiMessageAlertOutline, mdiThumbUpOutline } from '@mdi/js'
import Icon from '@mdi/react'
import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'

const Header = ({ feedbackType }: { feedbackType: string }) => {
    const { t } = useTranslation()
    const borderColor = useColorModeValue('gray.300', 'gray.700')

    return (
        <DrawerHeader borderBottomWidth="1px" borderColor={borderColor} px="0" py="24px">
            {feedbackType === 'positive' && (
                <Box display="flex" alignItems="center">
                    <Icon path={mdiThumbUpOutline} size={1} color="var(--chakra-colors-gray-500)" />
                    <Text ml="18px">{t('chat.feedback.drawer.positiveTitle')}</Text>
                </Box>
            )}
            {feedbackType === 'negative' && (
                <Box display="flex" alignItems="center">
                    <Icon path={mdiMessageAlertOutline} size={1} />
                    <Text ml="18px">{t('chat.feedback.drawer.title')}</Text>
                </Box>
            )}
        </DrawerHeader>
    )
}

export default Header
